import type { StaffTokenBalance } from '../types';

/**
 * Which balance represents a staff member when only one can be shown.
 *
 * Company-scope staff hold one balance per location they consume at. The wallet
 * used to fetch with `page_size: 1` and take whatever row came first, so it
 * could show one location's debt while the settle dialog cleared another's.
 * The balance that actually owes wins; with no debt anywhere, the first row is
 * as good as any.
 */
export function pickPrimaryTokenBalance(
  balances: StaffTokenBalance[],
): StaffTokenBalance | null {
  return balances.find((b) => b.debtTokens > 0) ?? balances[0] ?? null;
}

// `summarizeTokenBalances` lived here until the server grew
// `staff-token-balances/staff-summary/`. Totalling in the browser could only
// ever sum the rows that arrived, which is why the totals and the coverage
// line are now both read from that endpoint.
